import { API_MYEDUZZ } from 'settings';
import { apiServiceProxy } from 'v2/services/api-proxy';
import type { ApiServiceProxy } from 'v2/services/api-proxy';

class ConnectService {
  constructor(private apiService: ApiServiceProxy) {}

  public async listMyConnects(pagination: { per_page: number; current_page: number }) {
    return this.apiService.get(
      `${API_MYEDUZZ}/connect?per_page=${pagination.per_page}&page=${pagination.current_page}`
    );
  }

  public async listAutoresponders() {
    return this.apiService.get(`${API_MYEDUZZ}/connect/autoresponders`);
  }

  public async listActions(connectId: number) {
    return this.apiService.get(`${API_MYEDUZZ}/connect/${connectId}/actions`);
  }

  public async createConnect(connect: any) {
    return this.apiService.post(`${API_MYEDUZZ}/connect`, connect);
  }

  public async createAction(connectId: number, action: any) {
    return this.apiService.post(`${API_MYEDUZZ}/connect/${connectId}/actions`, {
      ...action,
      active: action.active ? 1 : 0
    });
  }

  public async listTriggers() {
    return this.apiService.get(`${API_MYEDUZZ}/connect/triggers`);
  }

  public async listConnectProducts() {
    return this.apiService.get(`${API_MYEDUZZ}/connect/autoresponders/products`);
  }

  public async listOptions(autoResponderId: number) {
    return this.apiService.get(`${API_MYEDUZZ}/connect/autoresponders/${autoResponderId}/options`);
  }

  public async loadConnect(connectId: number) {
    return this.apiService.get(`${API_MYEDUZZ}/connect/${connectId}`);
  }

  public async loadAction(connectId: number, actionId: number) {
    return this.apiService.get(`${API_MYEDUZZ}/connect/${connectId}/actions/${actionId}`);
  }

  public async updateAction(connectId: number, action: any) {
    return this.apiService.put(`${API_MYEDUZZ}/connect/${connectId}/actions/${action.id}`, {
      ...action,
      active: action.active ? 1 : 0
    });
  }

  public async updateConnect(connect: any) {
    return this.apiService.put(`${API_MYEDUZZ}/connect/${connect.id}`, connect);
  }

  public async changeStatusConnect(connectId: number, active: boolean) {
    return this.apiService.put(`${API_MYEDUZZ}/connect/${connectId}/active`, { active });
  }

  public async getActionFields(autoResponder: number, provider: number, field: string, params?: string) {
    const queryParams = params ? `&${params}` : '';
    return this.apiService.get(
      `${API_MYEDUZZ}/connect/lists/${provider}/${autoResponder}?field=${field}${queryParams}`
    );
  }
}

export const connectService = new ConnectService(apiServiceProxy);
